import { isEmpty, findIndex } from "lodash";
import update from "react-addons-update";

class ErrorTabManager {
  constructor({ fieldApi, context }) {
    this.fieldApi = fieldApi;
    this.context = context;
    this.errorList = [];
    this.globalErrorList = [];
  }

  /**
   *
   * @param {validateFieldIdList} 如果传递了 validateFieldIdList ，则是分步模式
   */
  updateFormErrors({ validateFieldIdList } = {}) {
    this.errorList = [];
    this.context.store.getForm().items.forEach((state) => {
      // console.log(state,state.mutableStates)
      const data = this.fieldApi.freezeStateData(
        state.mutableStates,
        state,
        true
      );

      const {
        fieldId,
        label,
        hasError,
        errorMsg,
        corrected = false,
        correctionTip,
      } = data;
      if (this.fieldApi.getFieldProp(fieldId, "disableCollect")) return; // 滤除无须收集数据的字段
      if (hasError || (!corrected && !isEmpty(correctionTip))) {
        this.errorList.push({
          fieldId,
          label,
          hasError,
          errorMsg: errorMsg || correctionTip,
        });
      }
    });
    this.reportErrorList(true, this.errorList);
  }

  updateFieldError(fieldId, { hasError, errorMsg }) {
    const index = findIndex(this.errorList, (item) => item.fieldId === fieldId);
    const label = this.fieldApi.getFieldProp(fieldId, "label");
    const errorField = { fieldId, hasError, errorMsg, label };
    if (index === -1) {
      if (hasError) {
        this.errorList = update(this.errorList, { $push: [errorField] });
      }
    } else if (hasError) {
      this.errorList = update(this.errorList, {
        [index]: { $set: errorField },
      });
    } else {
      this.errorList = update(this.errorList, { $splice: [[index, 1]] });
    }
    this.reportErrorList(undefined, this.errorList);
  }

  updateCorrected(fieldId, hasError) {
    const correctionTip = this.fieldApi.getFieldProp(fieldId, "correctionTip");
    if (!hasError && !isEmpty(correctionTip)) {
      this.fieldApi.setFieldProp(fieldId, "corrected", true);
    }
  }

  updateGlobalError(fieldId, { hasError, globalErrorMsg }) {
    const index = findIndex(
      this.globalErrorList,
      (item) => item.fieldId === fieldId
    );
    const errorField = { fieldId, hasError, globalErrorMsg };
    if (hasError) {
      this.globalErrorList = update(this.globalErrorList, {
        $splice: [[index, 1, errorField]],
      });
    } else {
      this.globalErrorList = update(this.globalErrorList, {
        $splice: [[index, 1]],
      });
    }

    this.reportErrorList(undefined, undefined, this.globalErrorList);
  }

  reportErrorList(visible, errorList, globalErrorList) {
    this.context.emitter.emit("errorListChange", {
      visible,
      errorList,
      globalErrorList,
    });
  }

  bindErrorMsgChangeHandler(fieldId) {
    if (!fieldId) {
      return;
    }
    this.fieldApi.onValidationChange(fieldId, (hasError, errorMsg) => {
      // 更新 corrected
      this.updateCorrected(fieldId, hasError);
      this.updateFieldError(fieldId, { hasError, errorMsg });
    });

    this.fieldApi.onGlobalErrorMsgChange(
      fieldId,
      (hasError, globalErrorMsg) => {
        this.updateGlobalError(fieldId, { hasError, globalErrorMsg });
      }
    );
  }
}

export default ErrorTabManager;
